export default __webpack_public_path__ + "static/media/bancoppel.d519ad28.png";